var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.elementType,_vm._b({tag:"div",staticClass:"c_grid c_grid--js",style:(_vm.gridStyles)},'div',_vm.box,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }